
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.25 6.227c0-1.878-1.84-2.582-3.072-3.333A5.709 5.709 0 016 .75a6.315 6.315 0 01-2.178 2.175C2.607 3.723.733 4.38.75 6.258c0 3.13 3.191 3.803 4.777 1.862-.042 1.498-1.178 2.79-2.751 3.13h6.465c-1.58-.334-2.724-1.628-2.768-3.13 1.536 2.097 4.676 1.237 4.777-1.893z"}})])
          )
        }
      }
    